/*
 * Copyright (c) Worldline 2023.
 */

export const PopoverMode = {
    selectEvidencePart: 'SELECT',
    uploadEvidencePart: 'UPLOAD',
    dispatchEvidencePart: 'DISPATCH'
}